import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { ShieldCheck } from 'lucide-react';
import { Concession } from '../../lib/api';
import { useFormatters } from '../../contexts/PreferencesContext';

interface ReviewDecisionProps {
  concession: Concession;
}

export function ReviewDecision({ concession }: ReviewDecisionProps) {
  const { formatDate, formatDateTime } = useFormatters();

  if (!concession.reviewed_date) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Review Decision</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-muted-foreground">Reviewed By</Label>
            <p className="font-medium">{concession.reviewed_by_name || 'N/A'}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Reviewed Date</Label>
            <p className="font-medium">{formatDateTime(concession.reviewed_date)}</p>
          </div>
          {concession.quantity_approved && (
            <div>
              <Label className="text-muted-foreground">Quantity Approved</Label>
              <p className="font-medium">{concession.quantity_approved}</p>
            </div>
          )}
          {concession.valid_until && (
            <div>
              <Label className="text-muted-foreground">Valid Until</Label>
              <p className="font-medium">{formatDate(concession.valid_until)}</p>
            </div>
          )}
        </div>

        {concession.review_notes && (
          <div>
            <Label className="text-muted-foreground">Review Notes</Label>
            <p className="mt-1 whitespace-pre-wrap">{concession.review_notes}</p>
          </div>
        )}

        {concession.rejection_reason && (
          <div>
            <Label className="text-muted-foreground text-red-600">Rejection Reason</Label>
            <p className="mt-1 whitespace-pre-wrap text-red-700">{concession.rejection_reason}</p>
          </div>
        )}

        {concession.risk_accepted && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-green-600" />
            <div>
              <p className="font-medium text-green-800">Risk Accepted</p>
              <p className="text-sm text-green-600">
                By {concession.risk_accepted_by_name} on {concession.risk_accepted_date ? formatDateTime(concession.risk_accepted_date) : ''}
              </p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
